var cilMediaStepForward = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M328.845,236.582,134.285,92.463A24,24,0,0,0,96,111.749V399.985a23.979,23.979,0,0,0,38.285,19.286l194.56-144.118h0a24,24,0,0,0,0-38.57ZM128,384.1V127.63L301.119,255.867Z' class='ci-primary'/><rect width='32' height='336' x='384' y='88' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilMediaStepForward };

